export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-no-smoking-542b45bb1ded9a980ba53a39a7abbf26.svg";